import React from "react";

const FolderTitle = props => (
  <div className="folder__title">
    <span>{props.title}</span>
    <div
      className="di pa1 f4 pointer"
      onClick={() => props.openUpdateFolderModal(props.id)}
    >
      <i className="i-pencil" />
    </div>

    <div
      className="di pa1 f4 pointer"
      onClick={() => props.handleDeleteFolder(props.id)}
    >
      <i className="i-trash" />
    </div>
  </div>
);

export default FolderTitle;



// WEBPACK FOOTER //
// ./src/components/account/FolderTitle.js